<template>
    <el-dialog
        class="detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="版本详情"
        v-loading="loading"
    >
        <div class="container">
            <div class="formCont">
                <el-row>
                    <el-col :span="12">
                        <div class="label">发布标题：</div>
                        <div class="content">{{ msg.title }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">版本号：</div>
                        <div class="content">{{ msg.version }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <div class="label">发布日期：</div>
                        <div class="content">{{ msg.publish_time }}</div>
                    </el-col>
                    <el-col :span="12">
                        <div class="label">项目名称：</div>
                        <div class="content">{{ msg.project_name }}</div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="label">发布内容：</div>
                        <!-- <div class="content">{{ msg.content }}</div> -->
                        <div class="content">
                            <el-input
                                type="textarea"
                                placeholder="发布内容"
                                size="small"
                                v-model="msg.content"
                                :autosize="{ minRows: 8, maxRows: 10 }"
                                readonly
                            >
                            </el-input>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="detailVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
export default {
    name: "versionsDetail",
    data() {
        return {
            loading: false,
            msg: {},
            previewList: [],
            showReview: false,
        };
    },
    watch: {
        detailVisible: {
            handler(newValue) {
                if (newValue) {
                    this.versions();
                }
            },
        },
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
    },
    methods: {
        closeDialog() {
            this.$emit("update:detailVisible", false);
        },
        versions() {
            oaApi.versions({}, "get", this.tableItem.id).then((res) => {
                if (res) {
                    this.msg = res.data;
                }
            });
        },
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>

</style>